import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';
import {BasePalette} from '#core/application/modules/base-palette.js';

import {CardsAndPromotions} from '../cards-and-promotions.js';

import {avantgardeCardsFactory} from './avantgarde-cards.factory.js';

import SCHEMA from './avantgarde-cards.schema.yaml';
import PALETTE_SCHEMA from './avantgarde-cards.palette-schema.yaml';

class AvantgardeCardsFeature extends AbstractVisualFeature {
    get name() {
        return 'AvantgardeCards';
    }

    get enabled() {
        return BasePalette.isAvantgarde();
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return avantgardeCardsFactory(PALETTE);
    }
}

export const AvantgardeCards = new AvantgardeCardsFeature(CardsAndPromotions);
